import * as React from 'react'
import { styles } from './styles.css'

type Props = {
  htmlFor?: string
  children?: React.ReactNode
}

export const FormLabel: React.FC<Props> = ({ htmlFor, children }) => {
  return (
    <label htmlFor={htmlFor} className={styles.label}>
      {children}
    </label>
  )
}
